import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  printingCustomsformsTitle: {
    description: 'ssConnectEpics.printingCustomsformsTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Custom Form} one {Custom Form} other {Custom Forms}}...',
    id: 'xQBU4T',
  },
  printingLabelTitle: {
    description: 'ssConnectEpics.printingLabelTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Label} one {Label} other {Labels}}...',
    id: 'LYXkRe',
  },
  printingPackingSlipTitle: {
    description: 'ssConnectEpics.printingPackingSlipTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Packing Slip} one {Packing Slip} other {Packing Slips}}...',
    id: 'fyVPGQ',
  },
  printingEndOfDayFormTitle: {
    description: 'ssConnectEpics.printingEndOfDayFormTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {End Of Day Form} one {End Of Day Form} other {End Of Day Forms}}...',
    id: 'dONZSb',
  },
  printingHotkeysAndBarcodeTitle: {
    description: 'ssConnectEpics.printingHotkeysAndBarcodeTitle',
    defaultMessage: 'Printing Hotkeys and Barcode...',
    id: 'w2VZN8',
  },
  printingOrderSummaryTitle: {
    description: 'ssConnectEpics.printingOrderSummaryTitle',
    defaultMessage: 'Printing Order Summary...',
    id: '6V832u',
  },
  printingPickListTitle: {
    description: 'ssConnectEpics.printingPickListTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}}...',
    id: 'wLcro/',
  },
  connectPrinterErrorTitle: {
    description: 'ssConnectEpics.printingErrorTitle',
    defaultMessage: 'Printing Error',
    id: 'ZEE205',
  },
  printingErrorTitle: {
    description: 'error message indicating that the supplied document name was not printed',
    defaultMessage: 'ShipStation could not print the {documentName}',
    id: 'bKJnq9',
  },
  printingOtherFormsTitle: {
    description: 'title for other orders sent to printer message',
    defaultMessage: 'Printing Other Forms',
    id: 'RykJdA',
  },
  sentToPrinter: {
    description: 'ssConnectEpics.sentToPrinter',
    defaultMessage: 'Sending to {selectedPrinterName}.',
    id: 'NLbQ9A',
  },
  connectOfflineError: {
    description: 'Error message when ss connect is offline',
    defaultMessage: 'Printing Error - The ShipStation Connect workstation for the printer {selectedPrinterName} is offline',
    id: 'lDDrtl',
  },
  genericDocumentName: {
    description: 'the word "document" that can be used generically',
    defaultMessage: 'document',
    id: 'xozLWZ',
  },
  genericPrintingTitle: {
    description: 'generic printing title when custom title is not delivered',
    defaultMessage: 'Printing Document...',
    id: 'TKttC5',
  },
  printingLocationBarcodesTitle: {
    description: 'Title in notification when printing location barcodes',
    defaultMessage: 'Printing Locations Barcodes',
    id: 'WJWf1V',
  },
});
